<h1>Content</h1>
<app-content-items [layout]="layout$ | async"></app-content-items>